import React from 'react';
import { Toggle } from '../settingsPrimitives';
import { useTranslation } from 'react-i18next';
import { showDoneHint } from '../../extensions/bundled/task-manager/boardEditStats';
import './BoardEditModal.css';

/**
 * The board's switches, as rows of one bordered card (card 5.4): title, a
 * hint, and the Settings toggle on the right — the same switch every settings
 * page uses, so a board option reads like an app option.
 *
 * Two rows (Boards parity, 12.10.2026): "Show completed tasks" and "Progress
 * counts in column headers" — the per-board `showColumnProgress` flag (extras
 * §2.4: board record, reconciler, MCP, git export) that hides the progress bar
 * + "N open" under every list name in Kanban and List view.
 *
 * DECISION (plan §9.1, kept from the old checkbox):
 * `done` stays a FLAG, not a column. Labels are the categorisation mechanism; "done" is state.
 */
export default function BoardEditOptions({ showDoneTasks, onShowDoneTasks, doneCount, showColumnProgress = true, onShowColumnProgress, closeFromCommits = false, onCloseFromCommits }) {
  const { t } = useTranslation();
  return (
    <div className="board-edit-options">
      <div className="board-edit-option">
        <div className="board-edit-option-text">
          <span className="board-edit-option-title">Show completed tasks</span>
          <span className="board-edit-option-hint">{showDoneHint(doneCount)}</span>
        </div>
        <Toggle value={showDoneTasks} onChange={onShowDoneTasks} label="Show completed tasks" />
      </div>
      {onShowColumnProgress && (
        <div className="board-edit-option">
          <div className="board-edit-option-text">
            <span className="board-edit-option-title">Progress counts in column headers</span>
            <span className="board-edit-option-hint">Done / in progress bar under each list name.</span>
          </div>
          <Toggle value={showColumnProgress} onChange={onShowColumnProgress} label="Progress counts in column headers" />
        </div>
      )}
      {/* Commit ↔ task links, slice 3 (commitAutoClose.js). */}
      {onCloseFromCommits && (
        <div className="board-edit-option">
          <div className="board-edit-option-text">
            <span className="board-edit-option-title">{t('taskLinks.autoClose.title')}</span>
            <span className="board-edit-option-hint">{t('taskLinks.autoClose.hint')}</span>
          </div>
          <Toggle value={closeFromCommits} onChange={onCloseFromCommits} label={t('taskLinks.autoClose.title')} />
        </div>
      )}
    </div>
  );
}
